import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Alert, Divider, Stack, Typography } from '@mui/material';
import { ReactComponent as FAQSvg } from '../../svg/faq.svg';
import faqs from '../../utils/Faq.json';

const FAQPage = () => {
  return (
    <>
      <Stack direction="column" alignItems="center" spacing={0}>
        <FAQSvg width="150px" height="150px" />

        <Typography
          variant="h4"
          gutterBottom
          sx={{
            background: 'linear-gradient(to right, #49a7cc, #ffa680)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
          Fragen und Antworten
        </Typography>

        {faqs.map((faq, index) => (
          <Accordion key={index} sx={{ width: '100%' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>{faq.question}</AccordionSummary>
            <AccordionDetails>{faq.answer}</AccordionDetails>
          </Accordion>
        ))}
        <Divider sx={{ py: 2 }} />
        <Alert severity="info">
          Falls Du die Antwort auf Deine Frage hier nicht finden konntest, schreib bitte eine E-Mail an kindergarten.timetracker@gmail.com
        </Alert>
      </Stack>
    </>
  );
};
export default FAQPage;
